import GlobalStyles from '@mui/material/GlobalStyles';

/**
 * Quanto sobe o que fica fixo no rodapé da janela (os avisos do SnackbarContext, barras flutuantes como a
 * das ações em massa) quando outra peça fixa ocupa o canto de baixo, como um botão flutuante. Use no
 * `bottom`: `calc(16px + ${DESLOCAMENTO_INFERIOR})`. Sem ninguém ligando, vale 0.
 */
export const DESLOCAMENTO_INFERIOR = 'var(--deslocamento-inferior, 0px)';

/**
 * Liga o deslocamento inferior enquanto estiver montado (e, com `media`, só nessa media query). Quem põe a
 * peça fixa no canto renderiza isto junto com ela; os avisos e as barras não precisam saber de quem é.
 */
export default function DeslocamentoInferior({ px, media }: { px: number; media?: string }) {
  const regra = { ':root': { '--deslocamento-inferior': `${px}px` } };
  return <GlobalStyles styles={media ? { [media]: regra } : regra} />;
}
